import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { YesNoDynamicTitleMessageDialogComponent } from '../yes-no-dynamic-title-message-dialog/yes-no-dynamic-title-message-dialog.component';

@Component({
    selector: 'app-idle-popup',
    templateUrl: './idle-popup.component.html',
    styleUrls: ['./idle-popup.component.scss'],
    standalone: false
})
export class IdlePopupComponent implements  OnInit {
  title="";
  message="";
  yesButton:boolean;
  noButton:boolean;
  cancelButton:boolean;
  yesText:string;
  noText:string;
  cancelText:string;2
  count:number;
  timeLeft: number = 10;
  interval;

  constructor(
    public dialogRef: MatDialogRef<IdlePopupComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
     this.dialogRef.disableClose = true; 
     this.title=data.title;
     this.message=data.message;
     this.count=data.timeinseconds;
     this.startTimer();
    
   
    }

  close(): void {
    clearInterval(this.interval);
    this.dialogRef.close("No");
  }
 
  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.yes();
      }
    },1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }
  ngOnInit(): void {
   // this.canActivate();
  }

  yes(){
    clearInterval(this.interval);
    this.dialogRef.close("Yes");
  }
  no(){
    clearInterval(this.interval);
    this.dialogRef.close("No");
  }

  cancel(){
    clearInterval(this.interval);
    this.dialogRef.close("Cancel");
  }
}
